export const formLabelMessage = {
  saveDraftBPLabelSuccess: 'Labels successfully saved',
  publishBPLabelSuccess: 'Labels successfully published',
}